export default function () {
  return {
    chatConnection: null,
    connection: null,
    connecting: null,
    connected: null,
  }
}
